import { graphql, type VariablesOf } from '@newfront-insurance/graphql-frontend';

export const CREATE_NOVA_SCHEDULE = graphql(`
  mutation CreateNovaSchedule($command: CreateNovaScheduleInput!) {
    createNovaSchedule(command: $command) {
      uuid
    }
  }
`);

export type CreateNovaScheduleCommand = VariablesOf<typeof CREATE_NOVA_SCHEDULE>['command'];
